import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var popConfirmStyle = function popConfirmStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    defaultIconfontFamily = _getThemeData.defaultIconfontFamily;
  return css([".c7n-popover.c7n-popover .c7n-popover-content .c7n-popover-inner .c7n-popover-inner-content .c7n-popover-message .icon-warning::before{content:'\\e002';font-family:", ";}"], defaultIconfontFamily);
};
var popConfirmData = {
  name: 'popconfirm',
  data: [{}],
  fusionTemplate: true,
  onlyTemplate: {
    base: popConfirmStyle
  }
};
export default popConfirmData;